export const maxWidthVals = {
  pageMaxWidth: '1200px',
  uiMaxWidth: '635px',
};
